import { useT } from "@/context/LanguageContext";
import { translations } from "@/data/translations";
import { motion } from "framer-motion";
import PhoneMockup from "./PhoneMockup";

export default function AppScreenshots() {
  const t = useT(translations.screenshots);

  return (
    <section
      id="screenshots"
      data-testid="screenshots-section"
      className="relative py-20 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[#1a1f26]" />
      {/* Copper glow */}
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#b87b56]/5 rounded-full blur-[120px]" />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium tracking-[0.3em] uppercase text-[#b87b56]">
            {t.caption}
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold tracking-tight uppercase text-white mt-3"
            style={{ fontFamily: "Oswald, sans-serif" }}
          >
            {t.title}
          </h2>
          <p className="text-base md:text-lg text-slate-300 mt-4 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0 }}
            className="transform md:-rotate-6 md:translate-y-8"
          >
            <PhoneMockup variant="presets" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="transform scale-110 z-10"
          >
            <PhoneMockup variant="timer" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="transform md:rotate-6 md:translate-y-8"
          >
            <PhoneMockup variant="builder" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
